var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiEverywhere = function SvgEmojiEverywhere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 30 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.756 24.815a5.153 5.153 0 1 0 1.78 9.99.8.8 0 0 1 .993.389 5.85 5.85 0 0 0 5.22 3.203 5.85 5.85 0 0 0 5.219-3.203.8.8 0 0 1 .991-.39 5.153 5.153 0 1 0 1.174-9.953.801.801 0 0 1-.19-1.59 6.756 6.756 0 1 1-.884 13.252A7.45 7.45 0 0 1 14.75 40a7.45 7.45 0 0 1-6.312-3.487 6.756 6.756 0 1 1-.884-13.253.801.801 0 1 1-.19 1.591 5 5 0 0 0-.607-.036",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.747 26.932c7.437 0 13.466-6.03 13.466-13.466C28.213 6.029 22.184 0 14.747 0S1.281 6.029 1.281 13.466s6.03 13.466 13.466 13.466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M9.454 11.042a1.93 1.93 0 1 0 0-3.86 1.93 1.93 0 0 0 0 3.86m10.595 0a1.93 1.93 0 1 0 0-3.86 1.93 1.93 0 0 0 0 3.86m-5.3 11.116c4.352 0 7.881-2.601 7.881-5.808H6.867c0 3.207 3.529 5.808 7.882 5.808",
    clipRule: "evenodd"
  })));
};
export default SvgEmojiEverywhere;